import React from 'react';
import { StyleSheet, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import Icon from '../Icon';
import RowView from '../RowView';

const SelectorWidgetInput = ({ style, label, value, ...rest }) => {
  return (
    <TouchableOpacity {...rest}>
      <View style={[styles.container, style]}>
        <BaseText style={styles.label}>{label}</BaseText>
        <RowView style={CommonStyles.mt1}>
          {value ? (
            <BaseText style={styles.value}>{value}</BaseText>
          ) : (
            <BaseText style={styles.selector}>--None Selected--</BaseText>
          )}
          <Icon name="chevronDown" />
        </RowView>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    ...CommonProperties.py3,
    ...CommonProperties.px5,
  },
  label: {
    ...CommonProperties.h4,
    color: Color.grayText,
  },
  selector: {
    flex: 1,
    textAlign: 'center',
    ...CommonProperties.h4,
  },
  value: {
    flex: 1,
    ...CommonProperties.h2,
  },
});

export default SelectorWidgetInput;
